export default __webpack_public_path__ + "static/media/icon-view-grey.bdea02ee.svg";